export const enInactivePageTranslations = {
	inactivePage: {
		accountInactive: 'Account Inactive',
		accountSuspended: 'Your account has been suspended',
		accountSuspendedDesc: 'Your restaurant account is currently inactive. This could be due to payment issues, policy violations, or administrative reasons.',
		possibleReasons: 'Possible reasons:',
		paymentIssues: 'Payment or billing issues',
		policyViolation: 'Policy violation',
		adminAction: 'Administrative action',
		technicalIssues: 'Technical maintenance',
		whatCanYouDo: 'What you can do:',
		contactSupport: 'Contact Support',
		contactSupportDesc: 'Get in touch with our support team for assistance',
		retryCheck: 'Retry Check',
		retryCheckDesc: 'Check if your account status has been updated',
		supportEmail: 'support@restaurantmenu.com',
		backToLogin: 'Back to Login',
		or: 'or'
	}
}